import { apiClient } from './client';
import {
  ApiResponse,
  AvailabilityConfig,
  BookingPageProfile,
  InspectorPublicProfile,
} from '@/types';

export const availabilityApi = {
  // Authenticated. Inspector reads their own weekly schedule + blocked dates.
  get: async () =>
    apiClient.get<ApiResponse<AvailabilityConfig>>('/availability'),

  // Authenticated. Replaces both lists atomically — body is the full state.
  put: async (config: AvailabilityConfig) =>
    apiClient.put<ApiResponse<AvailabilityConfig>>('/availability', config),
};

export const bookingApi = {
  // Public, unauthenticated. Used by the booking page to load profile + slots.
  getProfile: async (slug: string) =>
    apiClient.get<ApiResponse<BookingPageProfile>>(
      `/book/${encodeURIComponent(slug)}`
    ),

  // Public, unauthenticated. Submit a booking; backend re-validates the slot
  // is still bookable to avoid double-booking races.
  create: async (
    slug: string,
    data: {
      clientName: string;
      clientEmail: string;
      clientPhone?: string;
      propertyAddress: string;
      scheduledDate: string; // ISO timestamp
      notes?: string;
    }
  ) =>
    apiClient.post<
      ApiResponse<{
        appointment: {
          id: string;
          scheduledDate: string;
          durationMinutes: number;
        };
        clientEmailSent: boolean;
        inspectorEmailSent: boolean;
      }>
    >(`/book/${encodeURIComponent(slug)}`, data),
};

export const inspectorApi = {
  // Public, unauthenticated. Read-only profile lookup powering /inspector/:slug.
  // Distinct from `bookingApi.getProfile` which also returns availability.
  getProfile: async (slug: string) =>
    apiClient.get<ApiResponse<InspectorPublicProfile>>(
      `/inspector/${encodeURIComponent(slug)}`
    ),
};
